export default __webpack_public_path__ + "static/media/l1-p2.c9268946.svg";